import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useFuncionarioAssinaturasFilters
 */

type State = {
  funcionario: number;
  status: number;
};

type Action = {
  setFuncionario: (funcionario: number) => void;
  setStatus: (status: number) => void;
};

export const useFuncionarioAssinaturasFilters = create<State & Action>((set) => ({
  funcionario: 0,
  status: 2,
  setFuncionario: (funcionario) => set({ funcionario }),
  setStatus: (status) => set({ status }),
}));